<template>
  <div class="page-wrapper">
    <b-row class="text-left d-flex">
      <b-col class="mb-3" sm="12" lg="6">
        <!-- Logo + Nome + Versão -->
        <div class="d-flex mb-5">
          <img
            width="75px"
            height="75px"
            src="../assets/kpdf.png"
            alt="Logo do KPDF"
          />
          <div class="ml-3">
            <span class="titulo">KPDF</span>
          </div>
        </div>

        <!-- Descrição do app -->
        <span class="titulo-section">DESCRIÇÃO</span>
        <p class="descricao mt-3">
          Visualize como PDF (DANFE, DACTE, DACTE-OS, etc.) os XMLs de
          documentos fiscais de forma simples e sem necessidade de uma conta na
          Klaus!
        </p>

        <h5>Recursos do KPDF</h5>
        <ul>
          <li>Sistema de abas que permite visualizar mais de uma nota</li>
          <li>Salvar a visualização como PDF</li>
          <li>Sistema de impressão</li>
          <li>Zoom embutido</li>
          <li>Uso offline</li>
          <li>Gratuito e sem necessidade de login</li>
        </ul>

        <!-- Galeria de screenshots
        <span class="titulo-section">SCREENSHOTS</span>
        <div class="galeria mt-3">
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/kpdf-1.png')"
              v-pswp="require('../assets/screenshots/kpdf-1.png')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/kpdf-2.jpg')"
              v-pswp="require('../assets/screenshots/kpdf-2.jpg')"
            />
          </Photoswipe>
          <Photoswipe>
            <img
              class="d-block img-fluid w-100"
              :src="require('../assets/screenshots/kpdf-3.jpg')"
              v-pswp="require('../assets/screenshots/kpdf-3.jpg')"
            />
          </Photoswipe>
        </div> -->
      </b-col> 
    </b-row>

    <!-- Modal de download -->
    <modal-download-suite
      @fechar-modal="fecharModal"
      :visibilidade="isModalVisivel"
    />
  </div>
</template>

<script>
import ModalDownloadSuite from "../components/ModalDownloadSuite.vue";
import mixin from "../mixins/mixin";
import "../assets/theme.css"
export default {
  name: "KPDF",
  components: {
    ModalDownloadSuite,
  },
  mixins: [mixin],
};
</script>
